import Vue from "vue";
import VueRouter from "vue-router";

// const routerPush = VueRouter.prototype.push
// VueRouter.prototype.push = function push(location) {
//   return routerPush.call(this, location).catch(error=> error)
// }


import cookie from 'vue-cookies'
// 引入组件
import Error404 from "./pages/error/Error404";
import publicIndexQh from "./pages/PublicIndex_qh";
import pubItemIndex from "./pages/PubItemIndex";
import pubGroupIndex from "./pages/PubGroupIndex";
import suggestIndex from "./pages/SuggestIndex";
import applyIndex from "./pages/ApplyIndex_qh";
import applyIndexMarriage from "./pages/ApplyIndex_marriage";
import suggests from "./pages/suggest/Suggests";
import suggests_zx from "./pages/suggest/SuggestsZx";
import suggests_ts from "./pages/suggest/SuggestsTs";
import arrange from "./pages/suggest/arrange";
import policyServiceIndex from "./pages/PolicyServiceIndex";
import noticeIndex from "./pages/NoticeIndex";
import marrayServiceIndex from './pages/MarrayServiceIndex'
import marrayDetail from "./pages/detail/MarrayDetail"
import guideIndex from "./pages/guide/GuideIndex";
import guideIndexList from "./pages/guide/GuideIndexList";
import cardMaking from "./pages/personal/CardMaking"
import magicCardMaking from "./pages/personal/MagicCardMaking"
import marriage from "./pages/personal/Marriage"
import ylNeedCardMaking from "./pages/personal/YlNeedCardMaking"
import appointment from "./pages/personal/Appointment"
import complaint from "./pages/personal/Complaint"
import consulting from "./pages/personal/Consulting"
import evaluation from "./pages/personal/Evaluation"
import message from "./pages/personal/Message"
import personalInfo from "./pages/personal/PersonalInfo"
import security from "./pages/personal/Security"
import suggestion from "./pages/personal/Suggestion"
import blanApply from "./pages/bizApplyQh/BlanApply";
import peopleCertification from "./pages/personal/PeopleCertification"
import PolicyDetail from "./pages/detail/PolicyDetail"
import knowDetail from "./pages/detail/KnowDetail"
import PolicyDetailWeb from "./pages/detail/PolicyDetailWeb.vue"
import NoticeDetail from "./pages/detail/NoticeDetail"
import SunNoticeDetail from "./pages/detail/SunNoticeDetail"
import enjoyTreatment from "./pages/usualservice/EnjoyTreatment"
import payList from "./pages/usualservice/PayList"
import policyServiceWebIndex from "./pages/PolicyServiceWebIndex"
import applyList from "./pages/usualservice/ApplyList"
import clpApply from "./pages/bizApplyQh/ClpApply"
import servicesAppointmentMarry from "./pages/appointment/ServicesAppointmentMarry"
import tombSweepingAppointment from "./pages/appointment/TombSweepingAppointment"
import helpSweepingAppointment from "./pages/appointment/HelpSweepingAppointment"
import funeralAppointment from "./pages/appointment/FuneralAppointment"
import userSearch from "./pages/search/UserSearch"
import communitySearch from "./pages/search/CommunitySearch"
import communitySearchDetail from "./pages/search/CommunitySearchDetail"
import orgSearch from "./pages/search/OrgSearch"
import socialSearch from "./pages/search/SocialSearch"
import socialSearchDetail from "./pages/search/SocialSearchDetail"
import orgSearchDetail from "./pages/search/OrgSearchDetail"
import enjoyTreat from "./pages/personal/EnjoyTreat"
import suggestList from "./pages/suggest/SuggestList"
import suggestDetail from "./pages/suggest/SuggestDetail"
import tyApply from "./pages/bizApplyQh/TyApply"
import pocApply from "./pages/bizApplyQh/PocApply"
import convenientIndex from "./pages/ConvenientIndex"
import appointmentIndex from "./pages/AppointmentIndex"
import fa from "element-ui/src/locale/lang/fa";
//法人办事
import magicApplyIndex from "./pages/MagicApplyIndex";
//法人办事申请页
import magicApply from "./pages/magicApply/MagicApply";

//第三方登录重定向返回，获取参数页面
import threeLoginCode from "./pages/ThreeLoginCode"
//qhmz统一认证登录
import qhmzTyrzLoginCode from "./pages/QhmzTyrzLoginCode"
//法人认证页面
import legalCertification from "./pages/personal/LegalCertification"
//养老需求评估
import ylNeedEvaluation from "./pages/bizApplyQh/YlNeedEvaluation"
//殡葬机构查询
import funeralInquiries from "./pages/search/FuneralInquiries"
//殡葬机构查询详情
import funeralInquiriesDetail from "./pages/search/FuneralInquiriesDetail"
//高龄津贴计算
import OLDCalculate from "./pages/calculate/OLDCalculate"
//事实无人抚养儿童计算
import BLANORPCalculation from "./pages/calculate/BLANORPCalculation"
//残疾人计算
import CLPCalculation from "./pages/calculate/CLPCalculation"
//特困供养补贴待遇计算
import NTFCalculation from "./pages/calculate/NTFCalculation"
//孤儿生活费待遇计算
import ORPCalculation from "./pages/calculate/ORPCalculation"
//低保金计算
import BLANCalculation from "./pages/calculate/BLANCalculation"
//登记机构查询
import marriageAppointment from "./pages/marriage/MarriageAppointment"
//登记机构申报
import marriageAppointmentSubmit from "./pages/marriage/MarriageAppointmentSubmit"
//婚姻登记机构查询
import marriageQuery from "./pages/search/MarriageQuery"
//婚姻登记机构查询详情
import marriageQueryDetail from "./pages/search/MarriageQueryDetail"
//殡葬机构
import institutionalQuery from "./pages/search/InstitutionalQuery"
//殡葬机构详情
import institutionalQueryDetail from "./pages/search/InstitutionalQueryDetail"
//殡葬预约
import organinfoList from "./pages/personal/OrganinfoList"
//殡葬预约提交
import organinfoListSubmit from "./pages/personal/OrganinfoListSubmit"

//节地生态葬
import jdApply from "./pages/bizApplyQh/JdApply"
import deregister from "./pages/personal/Deregister.vue";
// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: "/error404",
    component: Error404,
    name: "error404",
    meta: {
      title: '404错误',
      accessRight: false
    }
  },
  {
    path:"/organinfoListSubmit",
    component: organinfoListSubmit,
    name:"organinfoListSubmit",
    meta:{
      title:'殡葬预约提交',
      accessRight:true,
    }
  },
  {
    path:"/organinfoList",
    component: organinfoList,
    name:"organinfoList",
    meta:{
      title:'殡葬预约',
      accessRight:true,
    }
  },
  {
    path:"/institutionalQueryDetail",
    component: institutionalQueryDetail,
    name:"institutionalQueryDetail",
    meta:{
      title:'殡葬机构详情',
      accessRight:true,
    }
  },
  {
    path:"/institutionalQuery",
    component: institutionalQuery,
    name:"institutionalQuery",
    meta:{
      title:'殡葬机构',
      accessRight:true,
    }
  },
  {
    path:"/marriageQuery",
    component: marriageQuery,
    name:"marriageQuery",
    meta:{
      title:'婚姻登记机构',
      accessRight:true,
    }
  },
  {
    path:"/marriageQueryDetail",
    component: marriageQueryDetail,
    name:"marriageQueryDetail",
    meta:{
      title:'婚姻登记机构详情',
      accessRight:true,
    }
  },
  {
    path:"/marriageAppointmentSubmit",
    component: marriageAppointmentSubmit,
    name:"marriageAppointmentSubmit",
    meta:{
      title:'登记机构申报',
      accessRight:false,
    }
  },
  {
    path:"/marriageAppointment",
    component: marriageAppointment,
    name:"marriageAppointment",
    meta:{
      title:'登记机构查询',
      accessRight:false,
    }
  },
  {
    path:"/BLANCalculation",
    component: BLANCalculation,
    name:"BLANCalculation",
    meta:{
      title:'低保金计算',
      accessRight:false,
    }
  },
  {
    path:"/ORPCalculation",
    component: ORPCalculation,
    name:"ORPCalculation",
    meta:{
      title:'孤儿生活费待遇计算',
      accessRight:false,
    }
  },
  {
    path:"/CLPCalculation",
    component: CLPCalculation,
    name:"CLPCalculation",
    meta:{
      title:'残疾人计算',
      accessRight:false,
    }
  },
  {
    path:"/NTFCalculation",
    component: NTFCalculation,
    name:"NTFCalculation",
    meta:{
      title:'特困供养补贴待遇计算',
      accessRight:false,
    }
  },
  {
    path:"/BLANORPCalculation",
    component: BLANORPCalculation,
    name:"BLANORPCalculation",
    meta:{
      title:'事实无人抚养儿童计算',
      accessRight:false,
    }
  },
  {
    path:"/OLDCalculate",
    component: OLDCalculate,
    name:"OLDCalculate",
    meta:{
      title:'高龄津贴计算',
      accessRight:false,
    }
  },
  {
    path:"/threeLoginCode",
    component: threeLoginCode,
    name:"threeLoginCode",
    meta:{
      title:'第三方回调',
      accessRight:false,
    }
  },
  {
    path:"/qhmzTyrzLoginCode",
    component: qhmzTyrzLoginCode,
    name:"qhmzTyrzLoginCode",
    meta:{
      title:'青民通办统一认证-回调',
      accessRight:false,
    }
  },

  {
    path:"/funeralInquiries",
    component: funeralInquiries,
    name:"funeralInquiries",
    meta:{
      title:'殡葬机构查询',
      accessRight:false,
    }
  },
  {
    path:"/funeralInquiriesDetail",
    component: funeralInquiriesDetail,
    name:"funeralInquiriesDetail",
    meta:{
      title:'殡葬机构查询',
      accessRight:false,
    }
  },
  {
    path:"/magicApply",
    component: magicApply,
    name:"magicApply",
    meta:{
      title:'法人办事申请',
      accessRight:true,
    }
  },
  {
    path:"/funeralAppointment",
    component: funeralAppointment,
    name:"funeralAppointment",
    meta:{
      title:'殡葬业务预约',
      accessRight:true,
    }
  },
  {
    path:"/magicApplyIndex",
    component: magicApplyIndex,
    name:"magicApplyIndex",
    meta:{
      title:'法人办事',
      accessRight:true,
    }
  },
  {
    path:"/helpSweepingAppointment",
    component: helpSweepingAppointment,
    name:"helpSweepingAppointment",
    meta:{
      title:'代扫墓预约',
      accessRight:true,
    }
  },
  {
    path:"/tombSweepingAppointment",
    component: tombSweepingAppointment,
    name:"tombSweepingAppointment",
    meta:{
      title:'扫墓预约',
      accessRight:true,
    }
  },
  {
    path:"/servicesAppointmentMarry",
    component: servicesAppointmentMarry,
    name:"servicesAppointmentMarry",
    meta:{
      title:'婚事预约',
      accessRight:true,
    }
  },
  {
    path:"/orgSearchDetail",
    component: orgSearchDetail,
    name:"orgSearchDetail",
    meta:{
      title:'办事单位详细信息',
      accessRight:true,
    }
  },
  {
    path:"/socialSearchDetail",
    component: socialSearchDetail,
    name:"socialSearchDetail",
    meta:{
      title:'社会组织查询详细',
      accessRight:true,
    }
  },
  {
    path:"/socialSearch",
    component: socialSearch,
    name:"socialSearch",
    meta:{
      title:'社会组织查询',
      accessRight:true,
    }
  },
  {
    path:"/orgSearch",
    component: orgSearch,
    name:"orgSearch",
    meta:{
      title:'办事单位',
      accessRight:true,
    }
  },
  {
    path:"/communitySearchDetail",
    component: communitySearchDetail,
    name:"communitySearchDetail",
    meta:{
      title:'村庄/社区详细',
      accessRight:true,
    }
  },
  {
    path:"/communitySearch",
    component: communitySearch,
    name:"communitySearch",
    meta:{
      title:'村庄/社区查询',
      accessRight:true,
    }
  },
  {
    path:"/appointmentIndex",
    component: appointmentIndex,
    name:"appointmentIndex",
    meta:{
      title:'预约服务',
      accessRight:true,
    }
  },
  {
    path:"/convenientIndex",
    component: convenientIndex,
    name:"convenientIndex",
    meta:{
      title:'便民查询',
      accessRight:true,
    }
  },
  {
    path:"/userSearch",
    component: userSearch,
    name:"userSearch",
    meta:{
      title:'用户搜索',
      accessRight:true,
    }
  },
  {
    path: "/home",
    component: publicIndexQh,
    name: "home",
    meta: {
      title: '一网通办',
      accessRight: false,
    }
  } ,

  {
    path: "/pubItemIndex",
    component: pubItemIndex,
    name: "pubItemIndex",
    meta: {
      title: '公开公示',
      accessRight: false,
    }
  },
  {
    path: "/pubGroupIndex",
    component: pubGroupIndex,
    name: "pubGroupIndex",
    meta: {
      title: '公开公示',
      accessRight: false,
    }
  },
  {
    path: "/suggestIndex",
    component: suggestIndex,
    name: "suggestIndex",
    meta: {
      title: '阳光监督',
      accessRight: false,
    }
  },
  {
    path: "/applyIndex",
    component: applyIndex,
    name: "applyIndex",
    meta: {
      title: '个人办事',
      accessRight: false,
    }
  },
  {
    path: "/applyIndexMarriage",
    component: applyIndexMarriage,
    name: "applyIndexMarriage",
    meta: {
      title: '个人办事婚姻登记',
      accessRight: false,
    }
  },
  {
    path: "/policyServiceIndex",
    component: policyServiceIndex,
    name: "policyServiceIndex",
    meta: {
      title: '政策库',
      accessRight: false,
    }
  },
  {
    path: "/noticeIndex",
    component: noticeIndex,
    name: "noticeIndex",
    meta: {
      title: '通知公告',
      accessRight: true,
    }
  },
  {
    path: "/marrayServiceIndex",
    component: marrayServiceIndex,
    name: "marrayServiceIndex",
    meta: {
      title: '婚姻家庭辅导',
      accessRight: true,
    }
  },
  {
    path: "/marrayDetail",
    component: marrayDetail,
    name: "marrayDetail",
    meta: {
      title: '婚姻家庭辅导',
      accessRight: true,
    }
  },

  {
    path: "/guideIndex",
    component: guideIndex,
    name: "guideIndex",
    meta: {
      title: '办事指南',
      accessRight: true,
    }
  },
  {
    path: "/guideIndexList",
    component: guideIndexList,
    name: "guideIndexList",
    meta: {
      title: '办事指南',
      accessRight: true,
    }
  }
  ,
  {
    path: "/ylNeed_CardMaking",
    component: ylNeedCardMaking,
    name: "ylNeedCardMaking",
    meta: {
      title: '养老需求评估个人办件列表',
      accessRight: true,
    }
  },
  {
    path: "/personal_magicCardMaking",
    component: magicCardMaking,
    name: "magicCardMaking",
    meta: {
      title: '法人办件',
      accessRight: true,
    }
  },
  {
    path: "/personal_marriage",
    component: marriage,
    name: "marriage",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_cardMaking",
    component: cardMaking,
    name: "cardMaking",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_appointment",
    component: appointment,
    name: "appointment",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_enjoyTreat",
    component: enjoyTreat,
    name: "enjoyTreat",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_complaint",
    component: complaint,
    name: "complaint",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_consulting",
    component: consulting,
    name: "consulting",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_evaluation",
    component: evaluation,
    name: "evaluation",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },

  {
    path: "/personal_message",
    component: message,
    name: "message",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/deregister",
    component: deregister,
    name: "deregister",
    meta: {
      title: '账户注销',
      accessRight: true,
    }
  },
  {
    path: "/personal_personalInfo",
    component: personalInfo,
    name: "personalInfo",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_security",
    component: security,
    name: "security",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path: "/personal_suggestion",
    component: suggestion,
    name: "suggestion",
    meta: {
      title: '个人中心',
      accessRight: true,
    }
  },
  {
    path:"/blanApply",
    component: blanApply,
    name:"blanApply",
    meta:{
      title:'低保申请',
      accessRight:true,
    }
  },
  {
    path:"/peopleCertification",
    component: peopleCertification,
    name:"peopleCertification",
    meta:{
      title:'实名认证',
      accessRight:true,
    }
  },
  {
    path:"/arrange",
    component: arrange,
    name:"arrange",
    meta:{
      title:'我要预约',
      accessRight:true,
    }
  },
  {
    path:"/suggest",
    component: suggests,
    name:"suggest",
    meta:{
      title:'我要建议',
      accessRight:true,
    }
  },
  {
    path:"/suggest_zx",
    component: suggests_zx,
    name:"suggest_zx",
    meta:{
      title:'我要咨询',
      accessRight:true,
    }
  },
  {
    path:"/suggest_ts",
    component: suggests_ts,
    name:"suggest_ts",
    meta:{
      title:'我要投诉',
      accessRight:true,
    }
  },
  {
    path:"/policyServiceWebIndex",
    component: policyServiceWebIndex,
    name:"policyServiceWebIndex",
    meta:{
      title:'政策库',
      accessRight:false,
    }
  },
  {
    path:"/PolicyDetail",
    component: PolicyDetail,
    name:"PolicyDetail",
    meta:{
      title:'政策详情',
      accessRight:false,
    }
  },
  {
    path:"/knowDetail",
    component: knowDetail,
    name:"knowDetail",
    meta:{
      title:'政策详情',
      accessRight:false,
    }
  },
  {
    path:"/PolicyDetailWeb",
    component: PolicyDetailWeb,
    name:"PolicyDetailWeb",
    meta:{
      title:'政策详情',
      accessRight:false,
    }
  },
  ,
  {
    path:"/NoticeDetail",
    component: NoticeDetail,
    name:"NoticeDetail",
    meta:{
      title:'通知公告详情',
      accessRight:false,
    }
  },
  ,
  {
    path:"/SunNoticeDetail",
    component: SunNoticeDetail,
    name:"SunNoticeDetail",
    meta:{
      title:'阳光公式详情',
      accessRight:false,
    }
  },
  ,
  {
    path:"/enjoyTreatment",
    component: enjoyTreatment,
    name:"enjoyTreatment",
    meta:{
      title:'在享待遇查询',
      accessRight:false,
    }
  },
  ,
  {
    path:"/payList",
    component: payList,
    name:"payList",
    meta:{
      title:'资金发放情况',
      accessRight:false,
    }
  },{
    path:"/applyList",
    component: applyList,
    name:"applyList",
    meta:{
      title:'办件进度查询',
      accessRight:false,
    }
  },{
    path:"/clpApply",
    component: clpApply,
    name:"clpApply",
    meta:{
      title:'困难残疾人',
      accessRight:false,
    }
  },{
    path:"/suggestList",
    component: suggestList,
    name:"suggestList",
    meta:{
      title:'投诉一览',
      accessRight:false,
    }
  },{
    path:"/suggestDetail",
    component: suggestDetail,
    name:"suggestDetail",
    meta:{
      title:'投诉详情',
      accessRight:false,
    }
  },
  {
    path:"/tyApply",
    component: tyApply,
    name:"tyApply",
    meta:{
      title:'高龄补贴',
      accessRight:false,
    }

  },
  {
    path:"/pocApply",
    component: pocApply,
    name:"pocApply",
    meta:{
      title:'儿童福利',
      accessRight:false,
    }
  },
  {
    path:"/ylNeedEvaluation",
    component: ylNeedEvaluation,
    name:"ylNeedEvaluation",
    meta:{
      title:'养老需求评估',
      accessRight:true,
    }
  },
  {
    path:"/legalCertification",
    component: legalCertification,
    name:"legalCertification",
    meta:{
      title:'法人认证',
      accessRight:true,
    }
  },
  {
    path:"/jdApply",
    component: jdApply,
    name:"jdApply",
    meta:{
      title:'节地生态葬',
      accessRight:false,
    }
  },
  //====================================公众用户end=================================
];

const router =  new VueRouter({
  routes,
  mode: 'hash'
  ,base:'/qmtb/ywt_home'
  //  linkActiveClass: 'active-link',
  //  linkExactActiveClass: 'exact-active-link'
});

router.beforeEach((to, from, next) => {
  //读取sessionStorage的user
  // if(to.meta.title){
  //   document.title="民政一网通办";//to.meta.title
  // }

  var href = window.location.href;
  // console.log("href:",href);
  if (href.includes("/index_auth.html")) {
    var host=window.location.protocol+"//"+window.location.host;
    // let origin = window.location.origin;
    window.location.replace(host+'/qmtb/ywt_home/#/qhmzTyrzLoginCode?' + location.href.split('?')[1]);
  } else if (href.includes("/index.html?loginOut=public")) {
    next('error404')
  }
  else if (href.includes("/index.html")) {
    var host=window.location.protocol+"//"+window.location.host;
    // let origin = window.location.origin;
    window.location.replace(host+'/qmtb/ywt_home/#/threeLoginCode?' + location.href.split('?')[1]);
  }else{
  if (to.matched.length === 0) {  //如果未匹配到路由
    from.path ? next({path: from.path}) : next('error404');
  }
  // next();
  //这里可以默认一个openId，就可以不调用微信api，直接实现登陆逻辑了
  // var openId="o86mj1MZdbZBGDb8qaYByyslWcgU";
  // var wuId="1296391695922888704";
  // cookie.set("openId",openId);
  // cookie.set("wuId",wuId);
  // var openId=cookie.get('openId')
  var userId = cookie.get('userId')
  // var token=cookie.get('token')
  var wuType = cookie.get('wuType')
  //   //判断菜单功能是否需要登录鉴权，如果需要，则判断userId是否为空，如果为空，则去登录
  if (to.meta.accessRight) {
    // next('userLogin')
    // if (userId && userId !='-1' && userId !='') {
    next()
    // } else {
    //   //执行账号密码登录操作
    //     // to.meta.userType=='CUSTOMER'
    //     next('peopleLogin')
    // }
  } else {
    next()
  }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router_qh.js